(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uep-homepage"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.dataset.uepReady)return;
    root.dataset.uepReady='true';
    var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var reveal=root.querySelectorAll('.uep-reveal');
    if(reduced || !('IntersectionObserver' in window)){reveal.forEach(function(el){el.classList.add('is-visible')})}
    else{var appearance=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');appearance.unobserve(entry.target)}})},{threshold:.09});reveal.forEach(function(el){appearance.observe(el)})}

    var rail=root.querySelector('[data-product-rail]');
    var original=rail?Array.from(rail.querySelectorAll('[data-product-card]')):[];
    if(original.length>1){
      original.forEach(function(card){var clone=card.cloneNode(true);clone.setAttribute('aria-hidden','true');clone.querySelectorAll('a').forEach(function(link){link.setAttribute('tabindex','-1')});rail.appendChild(clone)});
      var timer,paused=false,visible=false;
      function span(){return original.length*(original[0].getBoundingClientRect().width+17)}
      function move(dir){var step=original[0].getBoundingClientRect().width+17;if(dir<0 && rail.scrollLeft<step*.4){rail.style.scrollBehavior='auto';rail.scrollLeft+=span();rail.style.scrollBehavior=''}rail.scrollBy({left:dir*step,behavior:reduced?'instant':'smooth'})}
      function stop(){clearInterval(timer)}
      function start(){stop();if(!reduced && !paused && visible && !document.hidden)timer=setInterval(function(){move(1)},3900)}
      rail.addEventListener('scroll',function(){if(rail.scrollLeft>=span()-2){rail.style.scrollBehavior='auto';rail.scrollLeft-=span();rail.style.scrollBehavior=''}},{passive:true});
      root.querySelector('[data-prev]').addEventListener('click',function(){move(-1);start()});root.querySelector('[data-next]').addEventListener('click',function(){move(1);start()});
      rail.addEventListener('mouseenter',function(){paused=true;stop()});rail.addEventListener('mouseleave',function(){paused=false;start()});rail.addEventListener('focusin',function(){paused=true;stop()});rail.addEventListener('focusout',function(){paused=false;start()});rail.addEventListener('touchstart',function(){paused=true;stop()},{passive:true});rail.addEventListener('touchend',function(){paused=false;start()},{passive:true});
      if('IntersectionObserver' in window){new IntersectionObserver(function(entries){visible=entries[0].isIntersecting;if(visible)start();else stop()},{threshold:.2}).observe(rail)}else{visible=true;start()}
      document.addEventListener('visibilitychange',function(){if(document.hidden)stop();else start()});
    }

    var storySources=Array.from(root.querySelectorAll('[data-story-source]'));
    var storyButtons=Array.from(root.querySelectorAll('[data-story]'));
    storyButtons.forEach(function(button){button.addEventListener('click',function(){var index=Number(button.dataset.story),source=storySources[index];if(!source)return;root.querySelector('[data-story-title]').textContent=source.dataset.title;root.querySelector('[data-story-text]').textContent=source.dataset.text;var link=root.querySelector('[data-story-link]');link.href=source.dataset.link;link.innerHTML=source.dataset.label+' <span aria-hidden="true">↗</span>';var img=root.querySelector('.uep-story__image');if(img && source.dataset.image){img.removeAttribute('srcset');img.removeAttribute('sizes');img.src=source.dataset.image;img.alt=source.dataset.alt}root.querySelector('[data-story-number]').textContent=String(index+1).padStart(2,'0');storyButtons.forEach(function(item){var active=item===button;item.classList.toggle('is-active',active);item.setAttribute('aria-pressed',String(active))})})});

    var quotes=[{text:'Customer care is amazing and friendly.',author:'Samantha Woodhams',context:'Customer review'},{text:'This really does stop the itch.',author:'Cath',context:'Sweet Itch Free review'},{text:'Perfect solution for those scared of spray.',author:'Evie',context:'Fly Repellent Wipes review'}];
    var quoteIndex=0,quoteTimer,card=root.querySelector('.uep-home-quotes__card');
    function showQuote(index){quoteIndex=(index+quotes.length)%quotes.length;var q=quotes[quoteIndex];root.querySelector('[data-quote-text]').textContent=q.text;root.querySelector('[data-quote-author]').textContent=q.author;root.querySelector('[data-quote-context]').textContent=q.context;var bar=card.querySelector('.uep-home-quotes__progress span');bar.style.animation='none';void bar.offsetWidth;bar.style.animation=''}
    function stopQuote(){clearInterval(quoteTimer);card.classList.add('is-paused')}
    function startQuote(){clearInterval(quoteTimer);if(!reduced && !document.hidden){card.classList.remove('is-paused');quoteTimer=setInterval(function(){showQuote(quoteIndex+1)},7000)}}
    root.querySelector('[data-quote-prev]').addEventListener('click',function(){showQuote(quoteIndex-1);startQuote()});root.querySelector('[data-quote-next]').addEventListener('click',function(){showQuote(quoteIndex+1);startQuote()});
    card.addEventListener('mouseenter',stopQuote);card.addEventListener('mouseleave',startQuote);card.addEventListener('focusin',stopQuote);card.addEventListener('focusout',startQuote);document.addEventListener('visibilitychange',function(){if(document.hidden)stopQuote();else startQuote()});startQuote();
  }
  function initAll(scope){(scope||document).querySelectorAll('.uep-home').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll(document)});else initAll(document);
  document.addEventListener('shopify:section:load',function(event){initAll(event.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uep-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('uep-review-carousel')) {
  customElements.define('uep-review-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.uep-carousel__track');
      this.controls = this.querySelector('.uep-carousel__controls');
      this.previous = this.querySelector('[data-direction="-1"]');
      this.next = this.querySelector('[data-direction="1"]');
      this.toggle = this.querySelector('[data-autoplay-toggle]');
      if (!this.track || !this.controls || !this.toggle) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.hovered = false;
      this.visible = false;
      this.sync = () => {
        this.toggle.textContent = this.paused ? this.toggle.dataset.play : this.toggle.dataset.pause;
        const canPlay = !this.paused && !this.hovered && this.visible && !document.hidden && this.track.scrollWidth > this.track.clientWidth + 2;
        if (!canPlay) {
          clearInterval(this.timer);
          this.timer = null;
        } else if (!this.timer) {
          this.timer = setInterval(() => this.move(1, true), 7000);
        }
      };
      this.stop = () => { this.paused = true; this.sync(); };
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.abs(this.track.scrollLeft);
        this.controls.hidden = max <= 2;
        this.previous.disabled = position <= 2;
        this.next.disabled = position >= max - 2;
        this.sync();
      };
      this.move = (direction, automatic = false) => {
        const card = this.track.firstElementChild;
        if (!card) return;
        const behavior = this.motion.matches ? 'instant' : 'smooth';
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (automatic && Math.abs(this.track.scrollLeft) >= max - 2) {
          this.track.scrollTo({ left: 0, behavior });
          return;
        }
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap) * (rtl ? -1 : 1), behavior });
      };
      this.controls.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button === this.toggle) {
          this.paused = !this.paused;
          this.sync();
        } else {
          this.stop();
          this.move(Number(button.dataset.direction));
        }
      }, options);
      this.track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        this.stop();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
      }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); }, options);
      this.addEventListener('focusin', event => { if (event.target !== this.toggle) this.stop(); }, options);
      this.track.addEventListener('pointerdown', this.stop, options);
      this.track.addEventListener('wheel', this.stop, { ...options, passive: true });
      this.track.addEventListener('scroll', this.update, { ...options, passive: true });
      document.addEventListener('visibilitychange', this.sync, options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.stop(); }, options);
      this.addEventListener('shopify:block:select', event => {
        this.stop();
        const card = event.target.closest('.uep-customer-review');
        if (card) card.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'nearest' });
      }, options);
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.visibilityObserver = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.sync();
      });
      this.visibilityObserver.observe(this);
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.visibilityObserver?.disconnect();
      clearInterval(this.timer);
      this.timer = null;
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
